import classes from "./Section5.module.css";

// Import images
import partner1 from "./partners/1.webp";
import partner2 from "./partners/2.webp";
import partner3 from "./partners/3.webp";
import partner4 from "./partners/4.webp";
import partner5 from "./partners/5.webp";
import partner6 from "./partners/6.webp";
import partner7 from "./partners/7.webp";
import partner8 from "./partners/8.webp";
import partner9 from "./partners/9.webp";
import partner10 from "./partners/10.webp";

const partners = [
  // partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
];

export default function Section5() {
  return (
    <section className={classes.section5Wrapper}>
      <div className={classes.container}>
        <div className={classes.section5Header}>
          <h2>Trusted Partners for Data Center Maintenance</h2>
          <p>
            Prime Cloud Systems works with top-rated partners to ensure reliable
            data center operations. Our vetted providers deliver expert support,
            preventive maintenance, and rapid service to minimize downtime and
            maximize performance.
          </p>
        </div>

        <div className={classes.partnersGrid}>
          {partners.map((partner, index) => (
            <div key={index} className={classes.partnerItem}>
              <img
                src={partner}
                alt={`Partner ${index + 1}`}
                className={classes.partnerImage}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
